export const THUMBNAIL_WIDTH = 100;
export const IS_TRACK = 'IS_TRACK';
export const IS_GROUP = 'IS_GROUP';
export const IS_SEND = 'IS_SEND';

export const HIDE = 'HIDE';
export const TRACK = 'TRACK';
export const EFFECTS = 'EFFECTS';
export const LFOS = 'LFOS';
export const PARAMETERS = 'PARAMETERS';
export const MIXES = 'ALL';
export const SUBSEQUENCE = 'SUBSEQUENCE';
